const youtubeEmbedSelector = '[data-youtube-embed]';

function getYouTubeVideo(source) {
    try {
        const url = new URL(source, window.location.href);
        const hostname = url.hostname.toLowerCase().replace(/^www\./, '');
        let videoId = null;

        if (hostname === 'youtu.be') {
            [videoId] = url.pathname.split('/').filter(Boolean);
        } else if (hostname === 'youtube.com' || hostname === 'youtube-nocookie.com') {
            const pathParts = url.pathname.split('/').filter(Boolean);
            if (pathParts[0] === 'embed') {
                videoId = pathParts[1] || null;
            }
        }

        if (!videoId || !/^[a-zA-Z0-9_-]{6,}$/.test(videoId)) {
            return null;
        }

        url.protocol = 'https:';
        url.hostname = 'www.youtube-nocookie.com';
        url.port = '';
        url.username = '';
        url.password = '';
        url.pathname = `/embed/${videoId}`;
        url.searchParams.delete('si');
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('enablejsapi', '1');
        url.searchParams.set('origin', window.location.origin);
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('rel', '0');

        return {
            embedUrl: url.href,
            thumbnailUrl: `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/maxresdefault.jpg`,
            thumbnailMobileUrl: `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/sddefault.jpg`,
            thumbnailFallbackUrl: `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`,
            videoId,
        };
    } catch (error) {
        return null;
    }
}

function restoreOriginalIframe(container, template) {
    container.replaceWith(template.content.cloneNode(true));
}

function initializeYouTubeEmbed(container) {
    const template = container.querySelector('template[data-youtube-iframe]');
    const playButton = container.querySelector('[data-youtube-play]');
    const iframe = template?.content.querySelector('iframe');
    const video = getYouTubeVideo(iframe?.getAttribute('src'));

    if (!template || !playButton || !iframe || !video) {
        if (template) {
            restoreOriginalIframe(container, template);
        }
        return;
    }

    const thumbnail = document.createElement('img');
    thumbnail.className = 'youtube-embed__thumbnail';
    thumbnail.crossOrigin = 'anonymous';
    thumbnail.src = video.thumbnailUrl;
    thumbnail.alt = '';
    thumbnail.width = 1280;
    thumbnail.height = 720;
    thumbnail.loading = 'lazy';
    thumbnail.decoding = 'async';
    thumbnail.referrerPolicy = 'no-referrer';
    const thumbnailPicture = document.createElement('picture');
    thumbnailPicture.className = 'youtube-embed__picture';
    const mobileThumbnail = document.createElement('source');
    mobileThumbnail.media = '(max-width: 748px)';
    mobileThumbnail.srcset = video.thumbnailMobileUrl;
    mobileThumbnail.width = 640;
    mobileThumbnail.height = 480;
    thumbnailPicture.append(mobileThumbnail, thumbnail);
    thumbnail.addEventListener('error', () => {
        if (thumbnail.src !== video.thumbnailFallbackUrl) {
            mobileThumbnail.remove();
            thumbnail.src = video.thumbnailFallbackUrl;
        }
    }, { once: true });
    playButton.prepend(thumbnailPicture);
    container.classList.add('youtube-embed--ready');

    playButton.addEventListener('click', () => {
        const player = iframe.cloneNode(true);
        player.src = video.embedUrl;
        player.title = container.dataset.youtubeLabel || player.title || 'YouTube';
        player.loading = 'eager';
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        player.style.marginTop = '0';
        player.classList.add('youtube-embed__iframe');
        container.replaceChildren(player);
        player.focus();
        container.dispatchEvent(new CustomEvent('youtube:activated', {
            bubbles: true,
            detail: { videoId: video.videoId },
        }));
    }, { once: true });
}

function initializeYouTubeEmbeds() {
    document.querySelectorAll(youtubeEmbedSelector).forEach(initializeYouTubeEmbed);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeYouTubeEmbeds, { once: true });
} else {
    initializeYouTubeEmbeds();
}
